import { Button, IllustrationType } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface SingleActionModalProps {
  onClose: () => void
  onSubmit: () => void
  loading: boolean
  title: string
  description: React.ReactNode
  iconName: IllustrationType
  submitButton: string
}

const SingleActionModal = ({
  onClose,
  onSubmit,
  loading,
  title,
  description,
  iconName,
  submitButton,
}: SingleActionModalProps) => {
  const submitModal = () => {
    onSubmit()
  }
  return (
    <Modal
      illustration={iconName}
      title={title}
      description={description}
      onClose={onClose}
      onSubmit={submitModal}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={loading} submit>
            {submitButton}
          </Button>
        </>
      }
    ></Modal>
  )
}

export default SingleActionModal
